import i18n from './i18n.js';
import { applyReferenceHrefs } from './refs-setting-logic.js';

const urlVars = (function (url) {
  const vars = {};
  const parts = url.replace(
    /[?&]+([^=&]+)=([^&]*)/gi,
    function (m, key, value) {
      vars[key] = value;
    }
  );
  return vars;
})(window.location.href);

export const localization = (function (textsObj, langCodeGiven) {
  let langCode = langCodeGiven.toLowerCase();

  if (
    langCode.substr(0, 5) === 'zh-tw' ||
    langCode.substr(0, 5) === 'zh-hk' ||
    langCode.substr(0, 7) === 'zh-hant'
  ) { langCode = 'zh-Hant'; } else if (langCode.substr(0, 2) === 'zh') langCode = 'zh-Hans';
  else if (langCode.substr(0, 2) === 'nb') langCode = 'no';
  else langCode = langCode.substr(0, 2);

  if (!!textsObj[langCode] !== true) langCode = 'en';

  document.getElementsByTagName('html')[0].setAttribute('lang', langCode);

  return {
    lang: langCode,
    getText: (key) => {
      if (!!textsObj[langCode][key] === true) return textsObj[langCode][key];
      // fallback en
      if (!!textsObj.en[key] === true) return textsObj.en[key];
      return '';
    }
  };
})(i18n, urlVars.lang || window.navigator.language);



export function setTextContent(textEls) {
  let i = 0;
  while (textEls[i]) {
    textEls[i].innerHTML = localization.getText(textEls[i].dataset.i18n);
    i++;
  }

  const d = new Date();
  let year = d.getFullYear();

  document.getElementById('year-1').innerHTML = year;
  document.getElementById('year-2').innerHTML = year;

  applyReferenceHrefs();
  document.querySelectorAll('.footer-legal [data-reference]').forEach((el) => {
    el.target = '_blank';
    el.rel = 'noopener noreferrer';
  });
}

export function setFontSizes() {
  horizontalOptimization();
  verticalOptimization();
  equalizeFonts('.achievements__list', '.comparing-item__title', '.gdpr-links');
}

function horizontalOptimization() {
  const els = document.getElementsByClassName('divtext');
  let refFontSize = 100,
    i = 0;
  while (!!els[i] === true) {
    els[i].removeAttribute('style');
    refFontSize = parseFloat(window.getComputedStyle(els[i], null).getPropertyValue('font-size'));
    els[i].style.fontSize = `${refFontSize}px`;
    while (els[i].clientWidth > els[i].parentNode.clientWidth) {
      refFontSize--;
      els[i].style.fontSize = `${refFontSize}px`;
      if (refFontSize <= 4) break;
    }
    i++;
  }
}

function verticalOptimization() {
  const parentElements = document.querySelectorAll('[data-vertical-optimization]');
  parentElements.forEach(elem => {
    const childrenElements = elem.children;

    const parentHeight = parseInt(
      window
        .getComputedStyle(elem, null)
        .getPropertyValue('height')
    );
    let max = parseFloat(
      window.getComputedStyle(childrenElements[0], null).getPropertyValue('height')
    );
    let el = childrenElements[0];
    for (let i = 0; i < childrenElements.length; i++) {
      const current = parseFloat(
        window.getComputedStyle(childrenElements[i], null).getPropertyValue('height')
      );
      if (current > max) {
        el = childrenElements[i];
        max = current;
      }
    }
    let fz = parseFloat(
      window.getComputedStyle(childrenElements[0], null).getPropertyValue('font-size')
    );
    while (
      parseInt(window.getComputedStyle(el, null).getPropertyValue('height')) >
      parentHeight
    ) {
      console.log('minfz');
      fz -= 0.3;
      el.style.fontSize = `${fz}px`;
    }

    for (const item of Array.from(childrenElements)) {
      item.style.fontSize = `${fz}px`;
    }
  });
}

function equalizeFonts(...selectors) {
  selectors.forEach((selector) => {
    const equalizeElements = document.querySelectorAll(`${selector} .divtext`);

    let min = parseFloat(
      window.getComputedStyle(equalizeElements[0], null).getPropertyValue('font-size')
    );

    for (const element of Array.from(equalizeElements)) {
      const current = parseFloat(
        window.getComputedStyle(element, null).getPropertyValue('font-size')
      );

      if (min > current) min = current;
    }

    for (const element of Array.from(equalizeElements)) {
      element.style.fontSize = min + 'px';
    }
  });
}
